var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { NotiService } from '@app/noti.service';
import { TranslateService } from '@ngx-translate/core';
var SimulatorComponent = /** @class */ (function () {
    function SimulatorComponent(router, util, api, notiService, translate) {
        this.router = router;
        this.util = util;
        this.api = api;
        this.notiService = notiService;
        this.translate = translate;
        this.debtNotMatch = false;
        this.step = 1;
        this.maxStep = 3;
        this.maxRefund = 1000000;
        this.isSmallScreen = false;
        this.depositAcc = [];
        this.debtAcc = [];
        this.refundList = [];
        this.totalDepositAcc = [];
        this.totalDebtAcc = [];
        this.start1 = "";
        this.end1 = "";
        this.amount1 = "";
        this.start2 = "";
        this.amount2 = "";
        this.remark1 = "";
        this.remark2 = "";
        this.bankList = [];
        this.lang = "th";
        this.menuEnabled = false;
    }
    SimulatorComponent.prototype.onResize = function (event) {
        this.isSmallScreen = window.innerWidth < 415 ? true : false;
    };
    SimulatorComponent.prototype.ngOnDestroy = function () {
        if (this.notiSubscription) {
            this.notiSubscription.unsubscribe();
        }
    };
    SimulatorComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var config, crisisConfig, isCrisis, menuList, thisMenu;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        return [4 /*yield*/, this.api.get("master", "configuration")];
                    case 1:
                        config = _a.sent();
                        crisisConfig = config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
                            isCrisis = true;
                        }
                        else {
                            isCrisis = false;
                        }
                        return [4 /*yield*/, this.api.get("master", "customerPortalMenuSetting")];
                    case 2:
                        menuList = _a.sent();
                        thisMenu = this.util.getMenuObj(menuList, "01", isCrisis);
                        if (!thisMenu.show) {
                            this.util.ShowWaiting(false);
                            setTimeout(function () {
                                _this.router.navigate(["mainmenu/index"]);
                            }, 500);
                            return [2 /*return*/];
                        }
                        else {
                            this.menuEnabled = true;
                        }
                        // let tmpLang = this.util.GetCurrentLang()
                        // this.lang = tmpLang.substring(0,2)
                        // this.util.SetLanguage(tmpLang)
                        this.notiSubscription = this.notiService.message.subscribe(function (_lang) {
                            _this.lang = _lang;
                            _this.setRemarkTranslate();
                        });
                        this.util.InitValidation();
                        return [4 /*yield*/, this.getSimulateConfig()];
                    case 3:
                        _a.sent();
                        this.bankList = //await this.api.get("master", "bank")
                            [
                                {
                                    dpa_bankid: "1",
                                    dpa_name: "A"
                                },
                                {
                                    dpa_bankid: "2",
                                    dpa_name: "B"
                                },
                                {
                                    dpa_bankid: "3",
                                    dpa_name: "C"
                                }
                            ];
                        this.isSmallScreen = window.innerWidth < 415 ? true : false;
                        this.addAcc();
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    SimulatorComponent.prototype.getSimulateConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.api.get("master", "simulateConfiguration")];
                    case 1:
                        _a.simConfig = _b.sent();
                        this.simConfig.forEach(function (c) {
                            if (c.dpa_isactive) {
                                _this.maxRefund = parseInt(c.dpa_value);
                            }
                            if (c.dpa_enddate == null) {
                                _this.start2 = c.dpa_startdate;
                                _this.amount2 = parseInt(c.dpa_value).toString();
                            }
                            else {
                                _this.start1 = c.dpa_startdate;
                                _this.end1 = c.dpa_enddate;
                                _this.amount1 = parseInt(c.dpa_value).toString();
                            }
                        });
                        this.setRemarkTranslate();
                        return [2 /*return*/];
                }
            });
        });
    };
    SimulatorComponent.prototype.setRemarkTranslate = function () {
        var rm1 = this.translate.get("SimulateProtect1");
        var rm2 = this.translate.get("SimulateProtect2");
        this.remark1 = rm1.value.replace("{0}", this.util.numberWithCommas(this.maxRefund));
        if (this.lang == "th") {
            this.remark2 = rm2.value.replace("{0}", this.util.transformDate(this.start2, "medium"))
                .replace("{1}", this.util.numberWithCommas(this.amount2));
            // .replace("{2}", this.util.transformDate(this.end1, "medium"))
            // .replace("{3}", this.util.transformDate(this.start2, "medium"))
            // .replace("{4}", this.util.numberWithCommas(this.amount2))
        }
        else {
            this.remark2 = rm2.value.replace("{0}", this.util.numberWithCommas(this.amount2))
                .replace("{1}", this.util.transformDateEn(this.start2, "medium"));
            // .replace("{2}", this.util.transformDateEn(this.end1, "medium"))
            // .replace("{3}", this.util.transformDateEn(this.start2, "medium"))
            // .replace("{4}", this.util.numberWithCommas(this.amount2))
        }
    };
    SimulatorComponent.prototype.prevStep = function () {
        this.step--;
    };
    SimulatorComponent.prototype.nextStep = function () {
        var _this = this;
        if (this.step == 1 && !this.isValidDepositList()) {
            this.util.ErrorDialog("กรุณากรอกข้อมูลให้ครบ");
            return;
        }
        else if (this.step == 2 && !this.isValidDebtList()) {
            this.util.ErrorDialog("กรุณากรอกข้อมูลให้ครบ");
            return;
        }
        this.step++;
        if (this.step == 2) {
            if (this.debtAcc == null || this.debtAcc.length == 0) {
                this.addDebt();
            }
        }
        else if (this.step == 3) {
            this.debtNotMatch = false;
            this.refundList = [];
            var _loop_1 = function (i) {
                var debtInDeposit = this_1.totalDebtAcc.filter(function (debt) {
                    return debt.bankName == _this.totalDepositAcc[i].bankName;
                });
                if (debtInDeposit != null && debtInDeposit.length > 0) {
                    var r = {};
                    r.bankName = this_1.totalDepositAcc[i].bankName;
                    r.deposit = parseInt(this_1.totalDepositAcc[i].total) - parseInt(debtInDeposit[0].total);
                    r.total = r.deposit > this_1.maxRefund ? this_1.maxRefund : r.deposit;
                    if (r.total < 0) {
                        r.total = 0;
                    }
                    this_1.refundList.push(r);
                    debtInDeposit[0].matchDeposit = true;
                }
                else {
                    var r = {};
                    r.bankName = this_1.totalDepositAcc[i].bankName;
                    r.deposit = parseInt(this_1.totalDepositAcc[i].total);
                    r.total = r.deposit > this_1.maxRefund ? this_1.maxRefund : r.deposit;
                    if (r.total < 0) {
                        r.total = 0;
                    }
                    this_1.refundList.push(r);
                }
            };
            var this_1 = this;
            for (var i = 0; i < this.totalDepositAcc.length; i++) {
                _loop_1(i);
            }
            var debtNotMatchList = this.totalDebtAcc.filter(function (d) {
                return d.matchDeposit != true;
            });
            this.debtNotMatch = debtNotMatchList != null && debtNotMatchList.length > 0;
        }
    };
    SimulatorComponent.prototype.addAcc = function () {
        if (!this.isValidDepositList() && this.depositAcc.length != 0) {
            this.util.WarningDialog("กรุณากรอกข้อมูลให้ครบ");
            return;
        }
        var acc = {};
        acc.selected = false;
        acc.bankId = "";
        acc.bankType = "";
        acc.amount = null;
        acc.shared = false;
        acc.percent = null;
        acc.percentValid = true;
        acc.bankName = "";
        acc.total = null;
        this.depositAcc.push(acc);
    };
    SimulatorComponent.prototype.deleteAcc = function (index) {
        this.depositAcc.splice(index, 1);
        this.calTotalStep1();
    };
    SimulatorComponent.prototype.addDebt = function () {
        if (!this.isValidDebtList() && this.debtAcc.length != 0) {
            this.util.WarningDialog("กรุณากรอกข้อมูลให้ครบ");
            return;
        }
        var acc = {};
        acc.selected = false;
        acc.bankId = "";
        acc.total = null;
        this.debtAcc.push(acc);
    };
    SimulatorComponent.prototype.deleteDebt = function (index) {
        this.debtAcc.splice(index, 1);
        this.calTotalStep2();
    };
    SimulatorComponent.prototype.onBankDepositChange = function (index) {
        var _this = this;
        var selectedBank = this.bankList.filter(function (b) {
            return b.dpa_bankid == _this.depositAcc[index].bankId;
        });
        if (selectedBank == null || selectedBank.length == 0) {
            this.depositAcc[index].bankName = "";
        }
        else {
            this.depositAcc[index].bankName = selectedBank[0].dpa_name;
        }
        if (this.step == 1) {
            this.calStep1(index);
        }
        this.step1FocusOut(index);
    };
    SimulatorComponent.prototype.onBankDebtChange = function (index) {
        var _this = this;
        var selectedBank = this.bankList.filter(function (b) {
            return b.dpa_bankid == _this.debtAcc[index].bankId;
        });
        if (selectedBank == null || selectedBank.length == 0) {
            this.debtAcc[index].bankName = "";
        }
        else {
            this.debtAcc[index].bankName = selectedBank[0].dpa_name;
        }
        if (this.step == 2) {
            this.calStep2(index);
        }
        this.step2FocusOut(index);
    };
    SimulatorComponent.prototype.calStep1 = function (index) {
        var _this = this;
        var dep = this.depositAcc[index];
        if (dep.bankId == "" || dep.amount == null || (dep.shared && (dep.percent == null || dep.percent <= 0))) {
            return;
        }
        this.totalDepositAcc = [];
        this.depositAcc.forEach(function (dep) {
            if (dep.shared && dep.percent > 0) {
                if (dep.percent >= 100) {
                    dep.percent = 99.99;
                }
                if (typeof (dep.amount) == "string") {
                    dep.total = parseInt(dep.amount.replaceAll(",", "")) * dep.percent / 100;
                }
                else {
                    dep.total = dep.amount * dep.percent / 100;
                }
            }
            else {
                if (typeof (dep.amount) == "string") {
                    dep.total = dep.amount.replaceAll(",", "");
                }
                else {
                    dep.total = dep.amount;
                }
            }
            var match = _this.totalDepositAcc.filter(function (d) {
                return d.bankId == dep.bankId;
            });
            if (match != null && match.length > 0) {
                var index_1 = _this.totalDepositAcc.indexOf(match[0]);
                var a = _this.totalDepositAcc[index_1].total;
                var b = dep.total;
                if (typeof (a) == "string") {
                    a = parseInt(_this.totalDepositAcc[index_1].total.replaceAll(",", ""));
                }
                if (typeof (b) == "string") {
                    b = parseInt(dep.total.replaceAll(",", ""));
                }
                _this.totalDepositAcc[index_1].total = a + b;
            }
            else {
                if (typeof (dep.total) == "string") {
                    dep.total = dep.total.replaceAll(",", "");
                }
                _this.totalDepositAcc.push(JSON.parse(JSON.stringify(dep)));
            }
        });
    };
    SimulatorComponent.prototype.calTotalStep1 = function () {
        var _this = this;
        this.totalDepositAcc = [];
        this.depositAcc.forEach(function (d) {
            var match = _this.totalDepositAcc.filter(function (td) {
                return td.bankId == d.bankId;
            });
            if (match != null && match.length > 0) {
                var index = _this.totalDepositAcc.indexOf(match[0]);
                var a = _this.totalDepositAcc[index].total;
                var b = d.total;
                if (typeof (a) == "string") {
                    a = parseInt(_this.totalDepositAcc[index].total.replaceAll(",", ""));
                }
                if (typeof (b) == "string") {
                    b = parseInt(d.total.replaceAll(",", ""));
                }
                _this.totalDepositAcc[index].total = a + b;
            }
            else {
                if (typeof (d.total) == "string") {
                    d.total = d.total.replaceAll(",", "");
                }
                _this.totalDepositAcc.push(JSON.parse(JSON.stringify(d)));
            }
        });
    };
    SimulatorComponent.prototype.calStep2 = function (index) {
        var _this = this;
        var depAc = this.debtAcc[index];
        if (depAc.bankId == "" || depAc.total == null) {
            return;
        }
        else {
            if (typeof (depAc.total) == "string") {
                depAc.total = depAc.total.replaceAll(",", "");
            }
        }
        this.totalDebtAcc = [];
        this.debtAcc.forEach(function (dep) {
            var match = _this.totalDebtAcc.filter(function (d) {
                return d.bankId == dep.bankId;
            });
            var aaa = _this.totalDebtAcc;
            if (match != null && match.length > 0) {
                var index_2 = _this.totalDebtAcc.indexOf(match[0]);
                var a = _this.totalDebtAcc[index_2].total;
                var b = dep.total;
                if (typeof (a) == "string") {
                    a = parseInt(_this.totalDebtAcc[index_2].total.replaceAll(",", ""));
                }
                if (typeof (b) == "string") {
                    b = parseInt(dep.total.replaceAll(",", ""));
                }
                _this.totalDebtAcc[index_2].total = a + b;
            }
            else {
                if (typeof (dep.total) == "string") {
                    dep.total = dep.total.replaceAll(",", "");
                }
                _this.totalDebtAcc.push(JSON.parse(JSON.stringify(dep)));
            }
            var bbbb = _this.totalDebtAcc;
            dep.total = (dep.total).toString().replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        });
    };
    SimulatorComponent.prototype.calTotalStep2 = function () {
        var _this = this;
        this.totalDebtAcc = [];
        this.debtAcc.forEach(function (d) {
            var match = _this.totalDebtAcc.filter(function (td) {
                return td.bankId == d.bankId;
            });
            var bbbb = _this.totalDebtAcc;
            if (match != null && match.length > 0) {
                var index = _this.totalDebtAcc.indexOf(match[0]);
                var a = _this.totalDebtAcc[index].total;
                var b = d.total;
                if (typeof (a) == "string") {
                    a = parseInt(_this.totalDebtAcc[index].total.replaceAll(",", ""));
                }
                if (typeof (b) == "string") {
                    b = parseInt(d.total.replaceAll(",", ""));
                }
                _this.totalDebtAcc[index].total = a + b;
            }
            else {
                if (typeof (d.total) == "string") {
                    d.total = d.total.replaceAll(",", "");
                }
                _this.totalDebtAcc.push(JSON.parse(JSON.stringify(d)));
            }
            d.total = (d.total).toString().replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        });
    };
    SimulatorComponent.prototype.goToIndex = function () {
        this.router.navigate(["mainmenu/index"]);
    };
    SimulatorComponent.prototype.numberAndDotOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 44) {
            if (charCode == 46) {
                if (event.target.value.indexOf(".") == -1) {
                    return true;
                }
                else {
                    // if(event.target.value.length - event.target.value.indexOf(".") > 2){
                    //   return false
                    // }
                    // else{
                    return true;
                    // }
                }
            }
            return false;
        }
        if (event.target.value.indexOf(".") == -1) {
            return true;
        }
        else {
            // if(event.target.value.length - event.target.value.indexOf(".") > 2){
            //   return false
            // }
            // else{
            return true;
            // }
        }
    };
    SimulatorComponent.prototype.isValidDepositList = function () {
        if (this.depositAcc == null || this.depositAcc.length == 0) {
            return false;
        }
        var isValid = true;
        this.depositAcc.forEach(function (d) {
            if (d.bankId == "" ||
                d.amount == null ||
                (d.shared && (d.percent == null || d.percent <= 0))) {
                isValid = false;
                return;
            }
        });
        return isValid;
    };
    SimulatorComponent.prototype.isValidDebtList = function () {
        if (this.debtAcc == null || this.debtAcc.length == 0) {
            return false;
        }
        var isValid = true;
        this.debtAcc.forEach(function (d) {
            if (d.bankId == "" || d.total == null) {
                isValid = false;
                return;
            }
        });
        return isValid;
    };
    SimulatorComponent.prototype.step1FocusOut = function (index) {
        if (this.depositAcc[index].amount == null) {
            return;
        }
        this.depositAcc[index].amount = this.depositAcc[index].amount.replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    SimulatorComponent.prototype.step2FocusOut = function (index) {
        if (this.debtAcc[index].total == null) {
            return;
        }
        this.debtAcc[index].total = this.debtAcc[index].total.replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    return SimulatorComponent;
}());
export { SimulatorComponent };



// WEBPACK FOOTER //
// ./src/app/simulator/simulator.component.ts.pre-build-optimizer.js